import React from 'react';

const Day = ({ svgRef, title, ...props }) => (
  <svg xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" width="1em" height="1em" ref={svgRef} {...props}>
    <title>{title}</title>
    <defs>
      <path
        id="Day_a"
        d="M851.162 334.154l-1.307-1.302 1.03-1.025 1.314 1.302zM848 337.27h2.182v1.462H848zm7.273-7.269h1.464v2.155h-1.464zm5.57 4.154l-1.025-1.025 1.302-1.302 1.025 1.025zm-.014 7.689l1.31 1.308-1.026 1.03-1.302-1.315zm.99-4.574H864v1.462h-2.182zm-5.824-3.653c2.405 0 4.359 1.963 4.359 4.379 0 2.415-1.954 4.379-4.359 4.379-2.405 0-4.359-1.964-4.359-4.379 0-2.416 1.954-4.379 4.359-4.379zm-.722 10.229h1.464V346h-1.464zm-4.117-2.017l1.026 1.026-1.302 1.31-1.025-1.026z"
      />
    </defs>
    <use fill="currentColor" xlinkHref="#Day_a" transform="translate(-848 -330)" />
  </svg>
);

export default Day;



// WEBPACK FOOTER //
// ./src/common/icons/Day.js